/* VESPER LUNA — Policy Content section: ToC builder + IntersectionObserver active highlight.
   Loads via <script defer>. Re-runs on shopify:section:load (Pitfall 10). */
(function () {
  'use strict';

  var TR_CHAR_MAP = {
    'ç': 'c', 'Ç': 'c', 'ğ': 'g', 'Ğ': 'g',
    'ı': 'i', 'İ': 'i', 'ö': 'o', 'Ö': 'o',
    'ş': 's', 'Ş': 's', 'ü': 'u', 'Ü': 'u'
  };

  function slugify(text) {
    var str = String(text || '');
    str = str.replace(/[çÇğĞıİöÖşŞüÜ]/g, function (ch) { return TR_CHAR_MAP[ch] || ch; });
    str = str.toLowerCase();
    if (str.normalize) {
      str = str.normalize('NFKD').replace(/[̀-ͯ]/g, '');
    }
    str = str.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 80);
    return str || 'section';
  }

  function buildToc(root, tocList) {
    while (tocList.firstChild) tocList.removeChild(tocList.firstChild);
    var headings = root.querySelectorAll('h2');
    var tocContainer = tocList.closest('[data-vl-policy-toc]');
    if (!headings.length) {
      if (tocContainer) tocContainer.hidden = true;
      return;
    }
    if (tocContainer) tocContainer.hidden = false;
    var used = Object.create(null);
    var linkMap = Object.create(null);
    Array.prototype.forEach.call(headings, function (h) {
      var base = slugify(h.textContent);
      var id = base;
      var n = 1;
      while (used[id]) { id = base + '-' + (++n); }
      used[id] = true;
      h.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent;
      a.setAttribute('data-vl-toc-link', id);
      li.appendChild(a);
      tocList.appendChild(li);
      linkMap[id] = a;
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            Object.keys(linkMap).forEach(function (k) {
              linkMap[k].classList.toggle('is-active', k === entry.target.id);
            });
          }
        });
      }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
      Array.prototype.forEach.call(headings, function (h) { io.observe(h); });
    }
  }

  function initOne(root) {
    var body = root.querySelector ? root.querySelector('[data-vl-policy-body]') : null;
    if (!body) return;
    var tocList = (root.querySelector ? root : document).querySelector('[data-vl-policy-toc-list]');
    if (!tocList) return;
    buildToc(body, tocList);
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-section-type="vl-policy-content"]');
    Array.prototype.forEach.call(sections, function (s) { initOne(s); });
    if (!sections.length) {
      // Fallback: structure may exist without our wrapper marker
      initOne(document);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  // Theme Editor live re-render hook
  document.addEventListener('shopify:section:load', function (e) {
    var section = e && e.target ? e.target : null;
    if (section && section.querySelector && section.querySelector('[data-vl-policy-body]')) {
      initOne(section);
    } else {
      initAll();
    }
  });
})();
